export default "__VITE_ASSET__319ee89a__"